import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import store, {history} from './utils/redux/store';
import * as serviceWorker from './serviceWorker';
import {Provider} from 'react-redux';
import {ConnectedRouter} from 'connected-react-router';
import './utils/i18n';
import './utils/yup';
import './assets/styles';
import ScrollToTop from './utils/router/ScrollToTop';
import App from './App';
import ReactHighCharts from 'react-highcharts';
import HighchartsExporting from 'highcharts-exporting';
import HighchartsExportCsv from 'highcharts-export-csv';
import {Slide, ToastContainer} from 'react-toastify';
import {I18nextProvider} from 'react-i18next';
import i18n from './utils/i18n';

HighchartsExporting(ReactHighCharts.Highcharts);
HighchartsExportCsv(ReactHighCharts.Highcharts);

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <ConnectedRouter history={history}>
        <ScrollToTop>
          <App />,
        </ScrollToTop>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
          transition={Slide}
        />
      </ConnectedRouter>
    </I18nextProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
